// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.canned-footer {\n  background-color: #fff;\n}\n.canned-reply-modal {\n  padding: 0px 1rem;\n  position: relative;\n}\n.canned-reply-modal-list {\n  height: 250px;\n  overflow: auto;\n}\n.attachments-list {\n  height: 40px;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
